module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"customViewMenu.delete":"Delete"}}')
  delete Component.options._Ctor
}
